import React from 'react';
import { ApolloError } from '@apollo/client';
import { CardActions } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import {
  Typography,
  CircularProgress,
  LinearProgress,
  Button,
  Divider,
  Card,
  CardContent,
} from '@occc/ui-design-system';

import { DisplayCategoryFormRenderProps } from '../types';

interface UpdateDisplayCategoryFormProps {
  children?: React.ReactNode;
  loading: boolean;
  loaded: boolean;
  error?: ApolloError;
  disabled: boolean;
  handleSubmit: DisplayCategoryFormRenderProps['handleSubmit'];
}

export const UpdateDisplayCategoryForm: React.FC<UpdateDisplayCategoryFormProps> = ({
  handleSubmit,
  loading,
  loaded,
  error,
  children,
  disabled,
}) => {
  const navigate = useNavigate();

  if (error) {
    return <Typography color='error'>Something went wrong. Please try again.</Typography>;
  }
  // initially loading
  if (loading && !loaded) {
    return <CircularProgress />;
  }

  if (!loaded) {
    return <Typography color='error'>No data. Something went wrong. Please try again.</Typography>;
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        {loading && <LinearProgress />}
        <CardContent>
          <Typography variant='h6' gutterBottom>
            Edit Display Category
          </Typography>
          {children}
        </CardContent>
        <Divider />
        <CardActions>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button variant='contained' color='primary' onClick={handleSubmit} disabled={disabled}>
            Save
          </Button>
        </CardActions>
      </Card>
    </form>
  );
};
